export default{
    cadastra:{
        method:'post',
        url:'decimo/cadastro'
    },
    pesquisatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    buscatrabalhador:{
        method:'post',
        url:'trabalhador/lotacao/busca'
    },
    delete:{
        method:'delete',
        url:'decimo/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'decimo/lista'
    },
    editar:{
        method:'get',
        url:'decimo/editar{/id}'
    },
    update:{
        method:'post',
        url:'decimo/update'
    },
    evento:{
        method:'get',
        url:'rescisaocontrato/evento/2200{/id}'
    },
    eventocadastra:{
        method:'put',
        url:'evento/update'
    },

    email:{
        method:'post',
        url:'decimo/email'
    },
}